import React, { useContext } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLaughWink, faClock ,faCalendarAlt, faTachometerAlt, faCog, faWrench, faFolder, faChartArea, faTable, faBowlFood, faUser, faCartShopping, faSignOutAlt } from '@fortawesome/free-solid-svg-icons';
import logo from '../assets/images/logo_header-1.png';
import { UserContext } from '../contexts/UserContext';


const Footer = () => {
    const navigate = useNavigate();
    
  
  
    return (
    <div className="content cont-footer">
        <div className="row">
            
            <div className="col-md-4 ">
                <p className='footer-tl mb-4 mt-3'>Contact</p>
                <p className="link-footer" ><strong>Adresse :</strong></p>
                <p className="link-footer" >21bis Boulevard Marcel Sembat,
                     <br/>11100 Narbonne</p>
                <p className="link-footer" ><strong>Téléphone :</strong></p>
                <p className="link-footer" >09.82.55.46.03</p>
              
            </div>
            <div className="col-md-5 ">
                <ul className='mt-3'>
                    <li className='mb-2'><Link className="link-footer"  to="https://restaurant-narbonne-istanbul.com/menu/">Menu</Link></li>
                    <li className='mb-2'><Link className="link-footer" to="https://restaurant-narbonne-istanbul.com/restaurant/">Restaurant</Link></li>
                    <li className='mb-2'><Link className="link-footer" to="https://restaurant-narbonne-istanbul.com/lequipe/" >L’équipe</Link></li>
                    <li className='mb-2'><Link className="link-footer" to="https://commande.restaurant-narbonne-istanbul.com/reservation" >Réserver une table</Link></li>
                    <li className='mb-2'><Link className="link-footer" to="https://restaurant-narbonne-istanbul.com/connexion/" >Connexion</Link></li>
                    <li className='mb-2'><Link className="link-footer" to="https://restaurant-narbonne-istanbul.com/menu/" >Vente à emporter</Link></li>
                    <li className='mb-2'><Link className="link-footer" to="https://restaurant-narbonne-istanbul.com/mentions-legales/" >Mentions légales</Link></li>
                   
                </ul>
            </div>
            <div className="col-md-3 d-flex justify-content-end">
                <Link className="" to="/admin">
                    <img className="" src={logo} alt="restaurant istanbul"/>
                </Link>
            </div>
        </div>
    </div> 

);
};

export default Footer;